import React from 'react';

import { Dialog, Typography } from '@mui/material';
import {
  redirectToLogin,
  redirectToSignup,
  setUnauthenticatedModalOpen,
  useIsAuthModalOpen,
} from 'src/auth';
import { AlineButton } from 'src/components';
import { LockAndKeyIcon } from 'src/components/icons/LockAndKeyIcon';
import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()(theme => ({
  body: {
    padding: theme.spacing(1.5),
  },
  buttonRow: {
    display: 'flex',
    flexDirection: 'row',
    gap: theme.spacing(2),
    justifyContent: 'flex-end',
    padding: theme.spacing(2, 0, 0, 0),
  },
  dialog: {
    borderRadius: theme.dialogStyles.borderRadius,
    width: theme.dialogStyles.standardDialogWidth,
  },
  noteContainer: {
    alignItems: 'center',
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(2),
    justifyContent: 'center',
    padding: theme.spacing(0, 4),
  },
  noteText: {
    fontSize: 24,
    fontWeight: 600,
  },
}));

export function UnauthenticatedModalProvider({
  children,
}: React.HTMLAttributes<HTMLElement>): JSX.Element {
  const open = useIsAuthModalOpen();

  return (
    <>
      {children}
      <UnauthenticatedModal open={open} />
    </>
  );
}

/**
 * Appears when an anonymous (unauthenticated) user attempts an authenticated action.
 */
function UnauthenticatedModal({ open }: { open: boolean }): JSX.Element {
  const { classes } = useStyles();

  return (
    <Dialog
      classes={{ paper: classes.dialog }}
      open={open}
      onClose={() => setUnauthenticatedModalOpen(false)}
    >
      <div className={classes.body}>
        <div className={classes.noteContainer}>
          <div>
            <LockAndKeyIcon height={120} width={128} />
          </div>
          <Typography className={classes.noteText}>
            {"Whoops, it looks like you're not logged in. Signup or login to continue!"}
          </Typography>
        </div>
        <div className={classes.buttonRow}>
          <AlineButton color="primary" variant="outlined" onClick={redirectToLogin}>
            Login
          </AlineButton>
          <AlineButton color="primary" variant="contained" onClick={redirectToSignup}>
            Signup
          </AlineButton>
        </div>
      </div>
    </Dialog>
  );
}
